import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useGetQuery } from '../../lib/api/get'
import { useGetMutateCall } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { NoDataCard } from '../../common/NoDataCard'
import { AttenButtons } from './AttenButtons'

export const ClassAttendance = ({ isLocalEnvironment, routeData }) => {
  var curr = new Date()
  curr.setDate(curr.getDate())
  const getCallMutation = useGetMutateCall()
  const createCallMutation = useCreateCall()
  const [dates, setDates] = React.useState(curr.toISOString().substring(0, 10))
  const [roomVal, setRoomVal] = React.useState(null)
  const [selectRoom, setSelectRoom] = React.useState(false)
  const [freezAttendance, setFreezAttendance] = React.useState(false)
  const [selectedApplData, setSelectedApplData] = React.useState({
    data: { formData: [] },
  })

  const [submitData, setSubmitData] = React.useState([])
  const [updatedState, setUpdatedState] = React.useState(0)
  const [compUpdate, setCompUpdate] = React.useState(0)

  // function handleToggle(label) {
  //   const attenData = []
  //   selectedApplData.map((arr) => {
  //     if (arr.applicationId === label) {
  //       arr['absent'] = true
  //     }
  //     attenData.push(arr)
  //   })
  //   setSubmitData(attenData)
  // }

  const markAttendance = (d, t) => {
    const data = selectedApplData
    data.map((arr) => {
      if (arr.applicationId === d.applicationId) {
        arr['attendanceType'] = t
      }
    })
    setSelectedApplData(data)
    setSubmitData(data)
    setUpdatedState(updatedState + 1)
  }

  const submitBulkAttendance = async () => {
    const formData = []
    let finalFormData
    if (submitData.length > 0) {
      finalFormData = submitData.filter((f) => f.attendance.length <= 0)
    } else {
      finalFormData = selectedApplData.filter((f) => f.attendance.length <= 0)
    }
    // if (selectedApplDataChanged) {
    //   finalFormData.map((f) => {
    //     const dat = {}
    //     if (f.attendanceType !== 'a') {
    //       dat['applicationId'] = f.applicationId
    //       dat['applicationAYClassSctionId'] =
    //         f.applicationAYClassSections[0].applicationAYClassSectionId
    //       dat['checkInDateTime'] = new Date()
    //       formData.push(dat)
    //     }
    //   })
    // } else {
    //   selectedApplData.map((f) => {
    //     const dat = {}
    //     if (!f.absent) {
    //       dat['applicationId'] = f.applicationId
    //       dat['applicationAYClassSctionId'] =
    //         f.applicationAYClassSections[0].applicationAYClassSectionId
    //       dat['checkInDateTime'] = new Date()
    //       formData.push(dat)
    //     }
    //   })
    // }

    finalFormData.map((f) => {
      const dat = {}
      if (!f.attendanceType && f.attendanceType !== 'a') {
        dat['applicationId'] = f.applicationId
        dat['applicationAYClassSctionId'] =
          f.applicationAYClassSections[0].applicationAYClassSectionId
        dat['checkInDateTime'] = new Date()
        formData.push(dat)
      }
    })
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: 'attendance/bulk',
        id: '',
        parentAPI: 'classAttendance',
        data: { bulkData: formData }, //data,
        messageTitle: 'Class Attendance',
        message: 'Attendance Registered',
        params: '',
        isDynamic: true,
      })
      .then(async () => {
        setCompUpdate(compUpdate + 1)
        let rVal = '&classSectionId=' + roomVal
        await getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'classAttendance',
            params: '&checkInDateTime=' + dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss') + rVal,
            doPolling: false,
            isDynamic: true,
          })
          .then((resp) => {
            setSelectedApplData(resp.formData)
            setFreezAttendance(true)
          })
      })
  }

  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'classSections',
    params: '',
    isDynamic: true,
  })
  const getOnchangeAppl = async (e, classSectionId, onLoad = false) => {
    let rVal = onLoad ? '&classSectionId=' + classSectionId : ''
    if (roomVal !== null && roomVal !== '') {
      rVal = '&classSectionId=' + roomVal
    } else {
      if (!onLoad) {
        console.log('')
        setSelectRoom(true)
        return
      }
    }
    setFreezAttendance(false)
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'classAttendance',
        params: '&checkInDateTime=' + dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss') + rVal,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        setSelectedApplData(resp.formData)
        const hasAttendance = resp.formData.filter((f) => f.attendance.length > 0)
        if (hasAttendance.length > 0) {
          setFreezAttendance(true)
        }
      })
  }

  // const submitAttendance = async (formData, type) => {
  //   formData['attendanceType'] = type
  //   formData['checkInDateTime'] = dayjs(new Date())
  //   await createCallMutation
  //     .mutateAsync({
  //       url: isLocalEnvironment + '/addData',
  //       apiEndpoint: 'attendance',
  //       id: '',
  //       parentAPI: 'classAttendance',
  //       data: formData, //data,
  //       messageTitle: 'Class Attendance',
  //       message: 'Attendance Registered',
  //       params: '',
  //       isDynamic: true,
  //     })
  //     .then(() => {
  //       setCompUpdate(compUpdate + 1)
  //     })
  // }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false

  if (getData.isLoading) {
    return (
      <div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '20%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
            <div className="trtui-row">
              <div key="room" className="trtui-col-md-4 trtui-has-validation">
                <select
                  className={`trtui-form-control trtui-mb-2 ${selectRoom && 'trtui-is-invalid'}`}
                  style={{
                    paddingRight: 'calc(1.5em + 1rem)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                    backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                  }}
                  onChange={(e) => setRoomVal(e.target.value)}
                >
                  <option value={''}>Select Class</option>
                  {getData.data?.formData?.length > 0 &&
                    getData.data?.formData?.map((r, rInd) => (
                      <option
                        key={rInd}
                        value={r.classSectionId}
                        selected={roomVal === r.classSectionId ? true : false}
                      >
                        {r.classSectionName}
                      </option>
                    ))}
                </select>
                {selectRoom && <div className="trtui-invalid-feedback">Select Class</div>}
              </div>
              <div key="date" className="trtui-col-md-4">
                <input
                  type="date"
                  className="trtui-form-control"
                  onChange={(e) => setDates(e.target.value)}
                  defaultValue={dates}
                />
              </div>
              <div key="autoRefresh" className="trtui-col-md-4">
                {/* Auto Refresh{' '}
                        <input
                          className="trtui-form-check-input"
                          type="checkbox"
                          onChange={() => setAutoRefresh(!autoRefresh)}
                          style={{
                            '--vz-form-check-bg-image': `url(${checkBoxImg})`,
                          }}
                          checked={autoRefresh}
                        ></input> */}
                <button
                  className={`trtui-btn trtui-btn-primary`}
                  type="button"
                  onClick={() => getOnchangeAppl('date')}
                >
                  <i className="ri-search-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div key={`${updatedState}`} className="trtui-row">
          {selectedApplData.length > 0 &&
          dayjs(dates).format('DD-MM-YYYY') === dayjs().format('DD-MM-YYYY') ? (
            <div className="trtui-col-12 trtui-mb-2">
              <button
                className="trtui-btn trtui-btn-primary"
                onClick={() => submitBulkAttendance()}
                disabled={freezAttendance}
                title={freezAttendance ? 'Attendance is alredy submitted!' : 'Submit Attendance'}
              >
                {createCallMutation.isLoading ? (
                  <span className="trtui-d-flex trtui-align-items-center">
                    <span className="trtui-flex-grow-1 trtui-me-2">Submitting...</span>
                    <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                      <span className="trtui-visually-hidden">Submitting...</span>
                    </span>
                  </span>
                ) : (
                  <>{freezAttendance ? 'Attendance is alredy submitted!' : 'Submit Attendance'}</>
                )}
              </button>
            </div>
          ) : null}
          {dayjs(dates).format('DD-MM-YYYY') <= dayjs().format('DD-MM-YYYY') &&
          selectedApplData.length > 0 ? (
            selectedApplData
              .sort((a, b) => a.studentName - b.studentName)
              .map((card, cardInd) => (
                // <div key={cardInd}>{card.attendanceRegistration.studentName}</div>
                <div key={card.applicationId} className="trtui-row">
                  <div className="trtui-col-12">
                    <div
                      className="trtui-card mb-0 trtui-pt-2 trtui-pb-2"
                      style={{ marginBottom: '1rem' }}
                    >
                      <div className="trtui-card-body" style={{ paddingBottom: 0, paddingTop: 0 }}>
                        <div className="trtui-d-sm-flex trtui-align-items-center">
                          <div className="trtui-row" style={{ width: '100%' }}>
                            <div className="trtui-col-10">
                              <a href="#!">
                                <h5 className="trtui-fs-16">{card.studentName}</h5>
                              </a>
                            </div>
                            <div className="trtui-col-2 trtui-d-flex trtui-mt-0 trtui-text-muted trtui-mx-auto">
                              {/* <button
                                type="button"
                                className={`trtui-btn trtui-btn-sm ${card.attendance[0]?.checkInDateTime ? 'trtui-btn-success' : 'trtui-btn-soft-success'}`}
                                onClick={() =>
                                  submitAttendance(
                                    {
                                      applicationId: card.applicationId,
                                      applicationAYClassSectionId:
                                        card.applicationAYClassSections[0]
                                          .applicationAYClassSectionId,
                                    },
                                    1,
                                  )
                                }
                                disabled={
                                  createCallMutation.isLoading ||
                                  card.attendance[0]?.checkInDateTime
                                }
                              >
                                {createCallMutation.isLoading ? (
                                  <span className="trtui-d-flex trtui-align-items-center">
                                    <span className="trtui-flex-grow-1 trtui-me-2">Adding...</span>
                                    <span
                                      className="trtui-spinner-border trtui-flex-shrink-0"
                                      role="status"
                                    >
                                      <span className="trtui-visually-hidden">Adding...</span>
                                    </span>
                                  </span>
                                ) : (
                                  <>
                                    <span className="trtui-d-md-block trtui-d-none">Present</span>
                                    <span className="trtui-d-block trtui-d-md-none">
                                      <i className="ri-calendar-check-line" />
                                    </span>
                                  </>
                                )}
                              </button> */}
                              <AttenButtons
                                key={`${selectedApplData[cardInd]}${card.applicationId}`}
                                card={card}
                                markAttendance={markAttendance}
                                freezAttendance={freezAttendance}
                              />
                              {/* {card.attendanceType && card.attendanceType === 'p' ? (
                                <CheckBoxComponent
                                  key={card.applicationId} // Dont add index as the key, add some unique val
                                  label={card.applicationId}
                                  onSelect={handleToggle}
                                  stuDetails={card}
                                />
                              ) : null} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
          )}
        </div>
      )}
    </React.Fragment>
  )
}

ClassAttendance.propTypes = {
  isLocalEnvironment: PropTypes.string,
  envData: PropTypes.object,
  authDetails: PropTypes.object,
  routeData: PropTypes.object,
  label: PropTypes.string,
  onSelect: PropTypes.func,
  stuDetails: PropTypes.object,
  card: PropTypes.object,
}
